import { Navigate } from '@tanstack/react-router';
import React, { ReactNode } from 'react';
import { appRoutes } from 'utils/routing/routes';

type ProtectedRouteProps = {
  canAccessThisRoute: boolean;
  children: ReactNode;
  navigateTo?: string;
};

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  canAccessThisRoute,
  navigateTo = appRoutes.home,
}) => {
  if (canAccessThisRoute) return <>{children}</>;
  return <Navigate to={navigateTo} />;
};
